import { render, staticRenderFns } from "./DocumentTagWrapper.vue?vue&type=template&id=b570b9b2&"
import script from "./DocumentTagWrapper.vue?vue&type=script&lang=js&"
export * from "./DocumentTagWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTagWrapper.vue?vue&type=style&index=0&id=b570b9b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports